import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {SharedBoardsClient} from '@client/shared-boards-client'
import {IconButtonNew} from '@components/common/base/buttons'
import {InputNew} from '@components/common/base/input-new'
import {Tooltip} from '@components/common/tooltip/tooltip'
import {SearchFilter} from '@components/right-panel/search/search-filter'
import {SearchResultsNew} from '@components/right-panel/search/search-results-new'
import {
  PredefinedFilter,
  SearchContext,
  SearchStore,
  useSearchStore
} from '@components/right-panel/search/search-store'
import {getChatKind, keyboardHandler, useGlobalKeyDown} from '@containers/hooks'

const TwContainer = tw.div`
  min-h-0
  h-full
  p-8
  flex
  flex-col
  gap-8
`

const TwDivider = tw.div`
  border-solid
  border-0
  border-b-1
  -ml-8
  w-[calc(100%+16px)]
  border-line-base
`

export interface TaskChatListSearchProps {
  onClose: () => void
}

const availablePredefinedFilters: PredefinedFilter[] = [
  'everywhere',
  'chat-titles',
  'messages',
  'custom'
]

export const TaskChatListSearch = (props: TaskChatListSearchProps) => {
  const [store] = useState(
    () => new SearchStore('everywhere', availablePredefinedFilters, 20)
  )

  useGlobalKeyDown({
    escape: () => {
      // A chat opened in a right panel must be closed first
      if (getChatKind() !== 'empty') {
        return false
      }
      props.onClose()
      return true
    }
  })

  return (
    <SearchContext.Provider value={store}>
      <TaskChatListSearchBase {...props} />
    </SearchContext.Provider>
  )
}

const TaskChatListSearchBase = observer((props: TaskChatListSearchProps) => {
  const {onClose} = props
  const [state, store] = useSearchStore()

  const placeholder = SharedBoardsClient.getId()
    ? Lang.msg.share.searchBoard
    : Lang.msg.searchCompany

  return (
    <TwContainer>
      <div className="flex gap-8 items-center">
        <InputNew
          ref={store.setInputEl}
          iconLeft="IconSearch"
          iconRight={state.value ? 'IconX' : undefined}
          onIconRightClick={() => store.setValue('')}
          placeholder={placeholder}
          onChange={store.setValue}
          value={state.value}
          onFocus={store.startSearch}
          onKeyDown={keyboardHandler({escape: onClose})}
          autoFocus={state.selectedIx === -1}
          className="flex-1"
        />
        <Tooltip offset={[0, 5]} content={Lang.msg.closeSearch}>
          <IconButtonNew icon="IconX" className="m-4" onClick={onClose} />
        </Tooltip>
      </div>
      <SearchFilter />
      <TwDivider />
      <SearchResultsNew hideTitle refreshChangedProject={false} />
    </TwContainer>
  )
})
